module.exports = __webpack_public_path__ + "media/images/athletes/3547-b0476b5e0c67e1f2ac9d2dac1011b979.png";